var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 7.556h14m-8.75 3.555v5.333m3.5-5.333v5.333M5.875 7.556l.875 10.666c0 .472.184.924.513 1.257.328.334.773.521 1.237.521h7c.464 0 .91-.187 1.237-.52.329-.334.513-.786.513-1.258l.875-10.666m-8.75 0V4.889c0-.236.092-.462.256-.629A.868.868 0 0 1 10.25 4h3.5c.232 0 .455.094.619.26a.896.896 0 0 1 .256.629v2.667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon2);
export default __webpack_public_path__ + "static/media/delete-icon2.32bf26fe50f65f44b11b6fade54f10c8.svg";
export { ForwardRef as ReactComponent };